import React, { useRef, useState } from 'react';
import ThirdPartyModal from 'src/components/thirdPartyModal/ThirdPartyModal';
import NavigationModal from 'src/utils/NavigationModal';
import { useDisclosure } from '@mantine/hooks';
import { isThirdPartyNavId, isVisionNavId } from 'src/constants/navIdConstants';
import { getEnvVariable } from 'src/utils/envUtils';
const ROUTE_CHECK_DEFAULT = {
    setLciStarted: (started) => null,
    setLciCompleted: (completed) => null,
    setBdmStarted: (started) => null,
    setBdmCompleted: (completed) => null,
    navigationCheck: () => () => null,
};
export const RouteCheckContext = React.createContext(ROUTE_CHECK_DEFAULT);
/**
 * Provider to intercept certain routes and display modals to the user giving
 * them an option before they continue on to the final destination
 */
const RouteCheckProvider = ({ children }) => {
    const [lciStarted, setLciStarted] = useState(false);
    const [lciCompleted, setLciCompleted] = useState(false);
    const [bdmStarted, setBdmStarted] = useState(false);
    const [bdmCompleted, setBdmCompleted] = useState(false);
    const [isOpen, { open, close }] = useDisclosure(false);
    /*** NAVIGATION MODAL - FOR lci and bdm to prevent lost form data  */
    const setIsNavigationModalOpenRef = useRef(() => { });
    const setNavigationModalControl = (setIsOpen) => {
        setIsNavigationModalOpenRef.current = setIsOpen;
    };
    const [navigationCallback, setNavigationCallback] = useState(() => { });
    // Which wording the ThirdPartyModal shows. Only the vision link can be true, and only while the
    // visionThirdPartyModalEnabled flag is on for this environment; DHMO (and anything else routed
    // through navigationCheck) always stays false and keeps the legacy generic wording.
    const [isVisionExit, setIsVisionExit] = useState(false);
    const visionModalEnabled = !!getEnvVariable('visionThirdPartyModalEnabled');
    /**
     * Given a callback function that dictates what this link wants to do
     * Will check for any reason to block and show a modal
     * Sets appropriate callback so the modals will route to the desired destination
     */
    const navigationCheck = (callback, id) => () => {
        const path = window.location.pathname;
        let shouldBlockNav = false;
        let showThirdPartyModal = false;
        let showNavigationModal = false;
        // console.log('IN ROUTE CHECK');
        /* Check path or id to determine if modals need to stop navigation */
        if (path.includes('lci')) {
            if (lciStarted && !lciCompleted) {
                shouldBlockNav = true;
                showNavigationModal = true;
            }
        }
        else if (path.includes('bdm')) {
            if (bdmStarted && !bdmCompleted) {
                shouldBlockNav = true;
                showNavigationModal = true;
            }
        }
        else if (isThirdPartyNavId(id)) {
            shouldBlockNav = true;
            showThirdPartyModal = true;
        }
        /* render the modal and set appropriate callback */
        if (shouldBlockNav) {
            setNavigationCallback(() => callback);
            if (showNavigationModal) {
                setIsNavigationModalOpenRef.current(true);
            }
            else if (showThirdPartyModal) {
                setIsVisionExit(visionModalEnabled && isVisionNavId(id));
                open();
            }
        }
        else {
            callback();
        }
    };
    const context = {
        setLciStarted,
        setLciCompleted,
        setBdmStarted,
        setBdmCompleted,
        navigationCheck,
    };
    return (<RouteCheckContext.Provider value={context}>
      {children}
      <NavigationModal setControl={setNavigationModalControl} navigationCallback={navigationCallback} close={close} opened={isOpen}/>
      {/* Third-party ("you're leaving Lincoln Financial") warning — the rebranded ThirdPartyModal
            always renders here. Vision gets the Spectera copy (name hardcoded in ThirdPartyModalText)
            when the visionThirdPartyModalEnabled flag is on; DHMO (and anything else routed through
            navigationCheck) keeps the legacy generic wording, so its customer-facing text is
            unchanged. */}
      <ThirdPartyModal close={close} opened={isOpen} 
    // The stored callback is always a nullary void fn (see setNavigationCallback); cast to
    // satisfy ThirdPartyModal's stricter `() => void` prop without loosening its typing.
    navigationCallback={navigationCallback} isVision={isVisionExit}/>
    </RouteCheckContext.Provider>);
};
export default RouteCheckProvider;
